// extracted by mini-css-extract-plugin
export var root = "FaqPage-module--root--kKVlo";
export var title = "FaqPage-module--title--HSgOy";